// @flow
import React, { memo } from 'react';

import { Button } from '@box/blueprint-web';
import Link from 'box-ui-elements/es/components/link/Link';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';
import compose from 'lodash/flowRight';
import get from 'lodash/get';
import isAnonymousUser from '../../../common/utils/isAnonymousUser';
import { withCurrentUser } from '../../../common/current-user';
import css from './form-submit-action.module.scss';
import messages from './messages';
import type { User } from '../../../types/User';

type Props = InjectIntlProvidedProps & {
  currentUser: User,
  isAuthenticationRequired: boolean,
  isDisabled?: boolean,
  onSubmit: Function,
  submissionFailed: boolean,
  submitInProgress: boolean,
};

const FormSubmitAction = memo<Props>((props: Props) => {
  const {
    isAuthenticationRequired,
    isDisabled,
    onSubmit,
    submitInProgress,
    submissionFailed,
    intl,
    currentUser,
  } = props;
  const email = get(currentUser, 'email');

  const logout = (
    <>
      (
      {email && (
        <Link className={css.link} href="/logout">
          {intl.formatMessage(messages.logoutLink)}
        </Link>
      )}
      )
    </>
  );

  return (
    <div className={css.actionContainer}>
      <div className={css.submissionDetail}>
        {isAuthenticationRequired && !isAnonymousUser(currentUser) ? (
          <FormattedMessage
            {...messages.footerIsAuthenticationRequired}
            values={{
              email: <b>{email}</b>,
              logout,
            }}
          />
        ) : null}
      </div>
      <div className={css.buttonContainer}>
        <Button
          disabled={isDisabled || submitInProgress || submissionFailed}
          loading={submitInProgress}
          loadingAriaLabel={intl.formatMessage(messages.submitButtonLabel)}
          onClick={onSubmit}
          size="small"
          type="submit"
          variant="primary"
        >
          {intl.formatMessage(messages.submitButtonLabel)}
        </Button>
      </div>
    </div>
  );
});

export { FormSubmitAction };
export default compose(injectIntl, withCurrentUser)(FormSubmitAction);
